import Vue from 'vue'

export default {
  setAssignments (state, value) {
    state.assignments = value
  },
  setTeacherAssignments (state, value) {
    state.studentResponses = value
  },
  setScores (state, value) {
    state.scores = value
  },
  setAttachments (state, value) {
    state.answerAttachments = value
  },
  addAttachment (state, value) {
    state.answerAttachments.push(value)
  },
  removeAttachment (state, value) {
    if (value > -1) state.answerAttachments.splice(value, 1)
  },
  setAnswer (state, { index, value }) {
    Vue.set(state.assignments[index], 'answer', value)
  },
  setUnansweredAssignmentsCount (state, value) {
    state.unansweredAssignmentsCount = value
  }
}
